export const ToDoListAssistant = {
    "To Do List": {
        items: [
            // Using
            // Viewing your to do list items
            {
                heading: 'Viewing your to do list items',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['to do list', 'to do list screen', 'todolist', 'todo list', 'todo list screen', 'to do', 'todo'],
                sections: [
                    {
                        description: 'Your to do list items are shown on the main to do list screen',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListSelection',
                            action: 'highlight'
                        }
                    },
                ],
                options: [
                    {
                        option: 'Take me to the main to do list screen',
                        action: {
                            type: 'location',
                            value: '/Dashboard/ToDo',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Starting a new to do list
            {
                heading: 'Starting a new to do list',
                tags: ['to do list', 'to do list item', 'create', 'start', 'complete', 'todo list', 'todo list screen', 'to do', 'todo'],
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                sections: [
                    {
                        description: 'Click the Start New List button on the main to do list screen',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListCreateNewButton',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Search or select the list you would like to start and click next',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListCreateSelection',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Select if someone else will be assisting you with this list and click Next',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListAssistedSelection',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'If someone is assisting you with this list, select the name from the <b>Who will be assisting you</b> section',
                        styleAs: 'note',
                        ref: {
                            ref: 'ToDoListAssistedSelectionWho',
                            action: 'highlight'
                        }
                    },

                ],
                options: [{
                    option: 'Take me to the main to do list screen',
                    action: {
                        type: 'location',
                        value: '/Dashboard/ToDo',
                        params: { section: 'main' }
                    },

                },
                {
                    option: 'Take me to the new to do list screen',
                    action: {
                        type: 'location',
                        value: '/Dashboard/ToDo',
                        params: { section: 'Start New' }
                    },

                },
                ]
            },
            //Requesting assistance on a to do list
            {
                heading: 'Requesting assistance on a to do list',
                tags: ['to do list', 'to do list item', 'create', 'start', 'complete', 'todo list', 'todo list screen', 'to do', 'todo', 'assist', 'assistance'],
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                sections: [
                    {
                        description: 'On the main to do list screen, select the item you would like assistance with',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListSelection',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Select <b>Request assistance with this task</b>',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListRequestAssistanceButton',
                            action: 'highlight'
                        }
                    },

                    {
                        description: 'Search and select the user you would like to assist you',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListRequestAssistanceUser',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Select if you would like to assign only the current item or the entire to do list',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListRequestAssistanceUser',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'The list will then be added to that users to do list',
                        styleAs: 'note',
                    },
                ],
                options: [{
                    option: 'Take me to the main to do list screen',
                    action: {
                        type: 'location',
                        value: '/Dashboard/ToDo',
                        params: { section: 'main' }
                    },

                },
                ]
            },
            //Re-assigning a to do list
            {
                heading: 'Re-assigning a to do list',
                tags: ['to do list', 'to do list item', 'create', 'start', 'complete', 'todo list', 'todo list screen', 'to do', 'todo', 're-assign', 're assign', 'reassigning'],
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                sections: [
                    {
                        description: 'On the main to do list screen, select the item you would like to re-assign',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListSelection',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Select <b>Re-assign task</b>',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListRequestReAssignButton',
                            action: 'highlight'
                        }
                    },

                    {
                        description: 'Search and select the user you would like to re-assign the task to',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListRequestAssistanceUser',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Select if you would like to re-assign only the current item or the entire to do list',
                        styleAs: 'list',
                        ref: {
                            ref: 'ToDoListRequestAssistanceUser',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'The list will then be added to that users to do list',
                        styleAs: 'note',
                    },
                ],
                options: [{
                    option: 'Take me to the main to do list screen',
                    action: {
                        type: 'location',
                        value: '/Dashboard/ToDo',
                        params: { section: 'main' }
                    },

                },
                ]
            },
            // Management
            // Manage To Do List Templates
            {
                heading: 'Manage To Do List Templates',
                tags: ['to do list', 'set', 'setup', 'manageing', 'creating', 'template', 'todo list', 'todo list screen', 'to do', 'todo', 'template', 'remove', 'delete'],
                permissions: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'Facility Manager', 'Technical Support'],
                sections: [
                    {
                        description: 'Navigate the the facility setting by clicking the setting icon on the top right of the screen',
                        styleAs: 'list',
                        ref: {
                            ref: 'FaciltyConfigurationsButton',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Select Facility Configurations from the main menu on the left',
                        styleAs: 'list',
                        ref: {
                            ref: 'MenuFacility Configurations',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Select <b>To Do Lists</b>',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityConfigurationToDoLists',
                            action: 'highlight'
                        }
                    },
                ],
                options: [{
                    option: 'Take me to the to do list management screen',
                    action: {
                        type: 'location',
                        value: '/Facility/Configuration/ToDo',
                        params: { section: 'main' }
                    },

                },
                ]
            },
            // Setting up a new to do list template
            {
                heading: 'Setting up a new to do list template',
                tags: ['to do list', 'set', 'setup', 'manageing', 'creating', 'template', 'todo list', 'todo list screen', 'to do', 'todo'],
                permissions: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'Facility Manager', 'Technical Support'],
                sections: [
                    {
                        description: 'Navigate the the to do list management screen',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'To Do List',
                                sectionName: 'Manage To Do List Templates'
                            }
                        }
                    },
                    {
                        description: 'Enter a name in the new to do list name input section',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListName',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Click the add button',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListName',
                            action: 'highlight'
                        }
                    },
                ],
                options: [{}]
            },
            // Removing a to do list template
            {
                heading: 'Removing a to do list template',
                tags: ['to do list', 'set', 'setup', 'manageing', 'creating', 'template', 'todo list', 'todo list screen', 'to do', 'todo'],
                permissions: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'Facility Manager', 'Technical Support'],
                sections: [
                    {
                        description: 'Navigate the the to do list management screen',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'To Do List',
                                sectionName: 'Manage To Do List Templates'
                            }
                        }
                    },
                    {
                        description: 'On the line item of the list you would like to remove, click on the trash button',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListItems',
                            action: 'highlight'
                        }
                    },
                ],
                options: [{}]
            },
            // Renaming a to do list template
            {
                heading: 'Renaming a to do list template',
                tags: ['to do list', 'set', 'setup', 'manageing', 'creating', 'template', 'todo list', 'todo list screen', 'to do', 'todo', 'rename', 're name', 'change', 'name'],
                permissions: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'Facility Manager', 'Technical Support'],
                sections: [
                    {
                        description: 'Navigate the the to do list management screen',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'To Do List',
                                sectionName: 'Manage To Do List Templates'
                            }
                        }
                    },
                    {
                        description: 'On the line item of the list you would like to rename, click on the pencil button',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListItems',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Enter in the new name for the list',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListName',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Click the circled tick button to save the changes',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListName',
                            action: 'highlight'
                        }
                    },
                ],
                options: [{}]
            },
            // Creating a new item on a todo list template
            {
                heading: 'Creating a new item on a todo list template',
                tags: ['to do list', 'set', 'setup', 'manageing', 'creating', 'template', 'todo list', 'todo list screen', 'to do', 'todo', 'template', 'create', 'add'],
                permissions: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'Facility Manager', 'Technical Support'],
                sections: [
                    {
                        description: 'Navigate the the to do list management screen',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'To Do List',
                                sectionName: 'Manage To Do List Templates'
                            }
                        }
                    },
                    {
                        description: 'Select the to do list line item you would like to update',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListItems',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Enter a name for the list item, in the new item text field',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListItemNew',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Click the plus circle button to confirm',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListItemNew',
                            action: 'highlight'
                        }
                    },
                ],
                options: [{}]
            },
            // Renaming an item from a to do list template
            {
                heading: 'Renaming an item from a to do list template',
                tags: ['to do list', 'set', 'setup', 'manageing', 'creating', 'template', 'todo list', 'todo list screen', 'to do', 'todo', 'template', 'rename', 'item'],
                permissions: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'Facility Manager', 'Technical Support'],
                sections: [
                    {
                        description: 'Navigate the the to do list management screen',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'To Do List',
                                sectionName: 'Manage To Do List Templates'
                            }
                        }
                    },
                    {
                        description: 'Select the to do list line item you would like to update',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListItems',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Click the pencil icon on the to do list item line item you would like to update',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListItemNew',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Enter the new name for the list item',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListItemNew',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Click the circle tick icon to confirm',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListItemNew',
                            action: 'highlight'
                        }
                    },
                ],
                options: [{}]
            },
            // Removing an item from a to do list template
            {
                heading: 'Removing an item from a to do list template',
                tags: ['to do list', 'set', 'setup', 'manageing', 'creating', 'template', 'todo list', 'todo list screen', 'to do', 'todo', 'template', 'remove', 'item', 'delete'],
                permissions: ['System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Super', 'Facility Manager', 'Technical Support'],
                sections: [
                    {
                        description: 'Navigate the the to do list management screen',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'To Do List',
                                sectionName: 'Manage To Do List Templates'
                            }
                        }
                    },
                    {
                        description: 'Select the to do list line item you would like to update',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListItems',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Click the trash icon on the to do list item line item you would like to remove',
                        styleAs: 'list',
                        ref: {
                            ref: 'FacilityToDoListNewListItemItem',
                            action: 'highlight'
                        }
                    },
                ],
                options: [{}]
            },
        ]
    }
}